import axios from 'axios';
import SSEStreamer from '../../frontend/components/SSEStreamer';

export function isSuteBackend() {
  const apiUrl = String(axios.defaults.baseURL || '');
  const suteApiDomains = [
    'agents.sute.ai',
    'sute.prosperalabs.ai',
    'sute-staging.prosperalabs.ai',
    'sute-staging.staging.prosperalabs.ai',
    'sute_staging.prosperalabs.ai',
    'sute_staging.staging.prosperalabs.ai',
  ];
  return suteApiDomains.some((domain) => apiUrl.includes(domain));
}

const api = {
  async newMessage(
    conversation_id,
    message,
    content_blocks,
    conversation_token
  ) {
    const newMessageData = {
      content: message,
      conversation_token: conversation_token,
      content_blocks: content_blocks,
    };

    const response = await axios.post(
      `/conversation/${conversation_id}/message`,
      newMessageData
    );

    return response.data;
  },
  streamChatEvents(converation_id, conversation_token, mostRecentEventTime) {
    const apiUrl = String(axios.defaults.baseURL);
    let streamUri;
    if (apiUrl.endsWith('/')) {
      streamUri = apiUrl + `conversation/${converation_id}/message_stream`;
    } else {
      streamUri = apiUrl + `/conversation/${converation_id}/message_stream`;
    }

    if (conversation_token) {
      if (streamUri.includes('?')) {
        streamUri = streamUri + '&';
      } else {
        streamUri = streamUri + '?';
      }
      streamUri = streamUri + `conversation_token=${conversation_token}`;
    }

    if (mostRecentEventTime) {
      if (streamUri.includes('?')) {
        streamUri = streamUri + '&';
      } else {
        streamUri = streamUri + '?';
      }
      streamUri =
        streamUri + `since=${encodeURIComponent(mostRecentEventTime)}`;
    }

    // Make the streaming call with the same headers as a normal axios call, which will include the
    // authentication token if it's available
    const headers = axios.defaults.headers.common;

    // Construct the SSE streamer and return it.
    return new SSEStreamer(streamUri, 'GET', null, headers);
  },

  async emailDraftAction(conversationId, conversationToken, payload) {
    // payload: { action: 'send'|'edit'|'delete', draft_id, email_owner_user_id,
    //            email_provider, subject?, body? }
    const response = await axios.post(
      `/conversation/${conversationId}/email_draft_action`,
      {
        ...payload,
        conversation_token: conversationToken,
      }
    );
    return response.data;
  },

  async getWebChatConversation(conversationId, conversationToken) {
    const response = await axios.get(
      `/web_chat/conversation/${conversationId}`,
      {
        params: {
          conversation_token: conversationToken,
        },
      }
    );
    return response.data;
  },

  async getWebChatConfiguration() {
    const response = await axios.get(`/web_chat/configuration`);
    return response.data;
  },

  async getWebChatConfigurationDefaults() {
    const response = await axios.get(`/web_chat/configuration_defaults`);
    return response.data;
  },

  async saveWebChatConfiguration(newConfig) {
    const response = await axios.patch(`/web_chat/configuration`, newConfig);
    return response.data;
  },

  async startWebChatConversation(data) {
    const response = await axios.post(`/web_chat/conversation`, data);

    return response.data;
  },

  async upsertWebChatConversationMapping(conversationId, conversationToken) {
    // SUTE-only feature gate (clients using other backends should no-op)
    if (!isSuteBackend()) {
      return null;
    }

    try {
      const response = await axios.post(`/web_chat/conversation_mapping`, {
        conversation_id: conversationId,
        conversation_token: conversationToken,
      });
      return response.data;
    } catch (e) {
      // Backend is expected to 404 outside SUTE; don't fail the widget.
      return null;
    }
  },

  async getWebChatConfigurationForToken(token) {
    const response = await axios.get(`/web_chat/configuration/${token}`);
    return response.data;
  },
};

/** SUTE-only: register the current web chat thread for backend email notify lookup. */
export async function registerWebChatConversationMapping(conversation) {
  if (!conversation?._id || !conversation?.metadata?.conversation_token) {
    return null;
  }
  return api.upsertWebChatConversationMapping(
    conversation._id,
    conversation.metadata.conversation_token
  );
}

export default api;
